// removed by extract-text-webpack-plugin
module.exports = {"OrdersPage":"Orders__OrdersPage__3GBkl","Orders":"Orders__Orders__30Bmr","EmptyOrdersContainer":"Orders__EmptyOrdersContainer__1jV-T","LoginCard":"Orders__LoginCard__3cAQS","EmptyOrdersMessage":"Orders__EmptyOrdersMessage__31Sh-","title":"Orders__title__1QpFS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Orders/Orders.css
// module id = 160
// module chunks = 0